import React from "react";

import close from "../assets/images/Vector.png";
import uploaded from "../assets/images/uploaded.png";

import { FileItemProps } from "../types/type";
import { useTranslation } from "react-i18next";


const FileItem: React.FC<FileItemProps> = ({ loadOnly, file, onRemove }) => {
  const { t } = useTranslation();
  
  const filename = file.name.length > 40 ? `${ loadOnly ? file.name.substring(0, 120) : file.name.substring(0, 40) + '...'}` : file.name;

  return (
    <div className="flex wrap-range:flex-wrap flex-wra justify-between items-center bg-white rounded-xl p-4 shadow-sm">
      {/* Infos fichier */}
      <div className="flex flex-col flex-wrap">
        <h4 className="font-bold text-gray-800">{filename}</h4>

        {file.status === "uploading"  && (
          <p className="text-blue-500 flex gap-10">
            { !loadOnly && (<span>{file.loading}% {t("key_upload_uploading")}</span>)}
            <span>{file.size}</span>
          </p>
        )}

        {file.status === "done" && (
          <p className="text-blue-500">{t("key_upload_complete")}</p>
        )}

        {file.status === "error" && (
          <p className="text-red-500">{t("key_upload_error")}</p>
        )}
      </div>

      {/* Progression + actions */}
      <div className="flex items-center gap-4">
        {file.status === "uploading" && (
          <>
            { !loadOnly &&
            <progress
              value={file.loading}
              max={100}
              className="w-ful maxw-[15rem] h-1 appearance-none 
                [&::-webkit-progress-bar]:bg-gray-100 
                [&::-webkit-progress-value]:bg-blue-500 
                [&::-moz-progress-bar]:bg-blue-500 
                rounded-lg"
            ></progress>}
            <button
              className="text-gray-300 cursor-pointer hover:text-red-500 transition"
              onClick={onRemove}
            >
              <img src={close} alt="Cancel upload" />
            </button>
          </>
        )}

        {file.status === "done" && (
          <button className="text-gray-300 cursor-pointer hover:text-green-500 transition">
            <img src={uploaded} alt="Upload success" />
          </button>
        )}

        {file.status === "error" && (
          <button className="text-gray-300 cursor-pointer hover:text-orange-500 transition">
            ⚠️
          </button>
        )}
      </div>
    </div>
  );
};
export default FileItem;
